
import AppWarn from './errors/app-warns'
import http from './webhook/httpconfig'
import { cancelHTTPRequests } from '@/services/utils'
import { generateHeaders } from './webhook/webhook'

export async function getUserIPAddress() {
  let ip = ''
  try {
    const response = await http.request({
      method: 'get',
      url: `/api/ip`,
      headers: {
        'Cache-Control': 'no-cache',
        ...generateHeaders()
      },
      cancelToken: cancelHTTPRequests()
    })
    ip = response.data?.ip
  } catch (err) {
    throw new AppWarn({name: 'Get IP', message:`Error while fetching IP Address. ${err.message}`})
  }
  return ip
}
